"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureRegister = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LoginStyled = require("../LoginPage/LoginStyled");
var _Button = _interopRequireDefault(require("../Button"));
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _publisherIdHelper = _interopRequireDefault(require("../../util/publisherIdHelper"));
var _appConfigHelper = require("../../util/appConfigHelper");
var _RegisterForm = _interopRequireDefault(require("./RegisterForm"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Register extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "setPublisherId", value => this.setState({
      publisherId: value
    }));
    this.state = {
      publisherId: null
    };
  }
  componentDidMount() {
    const {
      urlProps
    } = this.props;
    if (urlProps.location) {
      (0, _publisherIdHelper.default)(urlProps.location, this.setPublisherId);
    } else {
      this.setPublisherId((0, _appConfigHelper.getData)('CLEENG_PUBLISHER_ID'));
    }
  }
  render() {
    const {
      publisherId
    } = this.state;
    const {
      t,
      onSuccess,
      onHaveAccountClick
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LoginStyled.LoginWrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LoginStyled.ContentWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RegisterForm.default, {
          t: t,
          publisherId: publisherId,
          onSuccess: onSuccess
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "secondary",
          size: "big",
          onClickFn: () => onHaveAccountClick(),
          children: t('Have an account?')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
    });
  }
}
exports.PureRegister = Register;
Register.propTypes = {
  urlProps: _propTypes.default.shape({
    location: _propTypes.default.shape({
      search: _propTypes.default.string
    })
  }),
  onSuccess: _propTypes.default.func,
  onHaveAccountClick: _propTypes.default.func,
  t: _propTypes.default.func
};
Register.defaultProps = {
  urlProps: {},
  onSuccess: () => null,
  onHaveAccountClick: () => null,
  t: k => k
};
var _default = exports.default = (0, _reactI18next.withTranslation)()(Register);